const gSearchInput = document.querySelector('#gsearch-input'); /* global search input */

const keyCode = Object.freeze({
    'RETURN': 13,
    'ESC': 27,
});

if (gSearchInput) {
    const formEl = gSearchInput.closest('#gsearch-form');

    const debounce = (func, wait) =>{
        let timeout;
        return function() {
            if (!timeout) func.apply(this, arguments);
            clearTimeout(timeout);
            timeout = setTimeout(()=>{timeout = null}, wait);
        }
    }

    const doSearch = debounce(() => {
        formEl.submit();
    }, 200);

    const resetButtonEl = formEl.querySelector('.js-button-reset');
    const goButtonEl = formEl.querySelector('.js-button-go');

    const initActionButtons = (val) => {
        resetButtonEl.disabled = !val;
        goButtonEl.disabled = !val;
    };
    initActionButtons(gSearchInput.value);

    resetButtonEl.addEventListener('click', (e) => {
        e.preventDefault();

        gSearchInput.value = '';
        initActionButtons(gSearchInput.value);
        doSearch();
    });

    gSearchInput.addEventListener('keyup', (e) => {
        initActionButtons(e.target.value);
    });

    gSearchInput.addEventListener('keydown', (e) => {
        var flag = false;

        switch (e.keyCode) {
            case keyCode.RETURN:
                doSearch();
                flag = true;
                break;

            case keyCode.ESC:
                e.target.blur();
                break;

            default:
                break;
        }

        if (flag) {
            e.stopPropagation();
            e.preventDefault();
        }
    });

    // initialize filters after refresh
    const params = new URLSearchParams(decodeURI(window.location.search));
    const termQT = params.get('term');
    const sortQT = params.get('sort');

    const handleDropdownChange = (dropdownID, value) => {
        const dropdownEl = formEl.querySelector('#' + dropdownID);
        dropdownEl.value = value;

        if ('createEvent' in document) {
            const evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            dropdownEl.dispatchEvent(evt);
        } else {
            dropdownEl.fireEvent("onchange");
        }
    };

    if (sortQT) {
        const dropdownEl = formEl.querySelector('[name="sort"]');
        handleDropdownChange(dropdownEl.getAttribute('id'), sortQT);
    }
}